export default __webpack_public_path__ + "static/media/1.dfbb5551.jpg";